<template>
    <div class="layer-container">
        <el-card class="box-card">
            <div slot="header" class="clearfix header">
                <span>TMS服务</span>
                <div>

                </div>
            </div>
            <div class="content">
                <el-table :data="tmsArr" style="width: 100%" border>
                    <!-- <el-table-column type="selection" width="55"></el-table-column> -->
                    <el-table-column
                        prop="name"
                        label="服务名称"
                        width="160">
                    </el-table-column>
                    <el-table-column
                        prop="layer"
                        label="图层名称"
                        width="160">
                    </el-table-column>
                    <el-table-column
                        prop="path"
                        label="访问地址">
                    </el-table-column>
                </el-table>
                <el-pagination class="page" background layout="prev, pager, next" :total="dataTotal" :page-size="pageSize" :current-page.sync="pageNum" @current-change="pageChange"></el-pagination>
            </div>
        </el-card>
    </div>
</template>

<script>
import { listService } from '../../api/layerApi'
export default {
    name: 'ListTMS',
    components: {},
    data() {
        return {
            tmsArr: [],
            pageNum: 1,
            pageSize: 10,
            dataTotal: 0
        }
    },
    mounted() {
        this.loadTMS()
    },
    beforeDestroy() {
    },
    methods: {
        loadTMS() {
            listService({ name: 'TMS', pageNum: this.pageNum, pageSize: this.pageSize }).then(res => {
                if (res.data.code == 200) {
                    this.dataTotal = res.data.total
                    this.tmsArr = res.data.rows
                }
            })
        },
        pageChange(val) {
            this.pageNum = val
        }
    }
}
</script>

<style lang="scss" scoped>

/deep/.el-card{
    height: 100% !important;
}
/deep/.el-card__header{
    padding: 20px !important;
}
.layer-container {
    width: 100%;
    height: 100%;
    .header{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .content{
        display: flex;
        flex-direction: column;
        align-items: center;
        .search-form{
            width: 100%;
            display: flex;
            justify-content: flex-start;
            .submit-btn{
                margin-left: 30px;
            }
        }
        .page{
            position: absolute;
            bottom: 70px;
        }
    }
}
</style>

